import { BaseLayoutFactory } from "../global/base-layout-factory";
import { ContactProvider } from "./context/contact-context";
import { ContactComponent } from "./contact-component";

export function ContactFactory() {
    return (
        <BaseLayoutFactory>
            <ContactProvider>
                <ContactComponent />
            </ContactProvider>
        </BaseLayoutFactory>
    );
}
